const animateIcons = (state = 1) => {
  gsap.registerPlugin(MorphSVGPlugin);
  const focus = document.getElementById('icon-svg-focus');
  const restorative = document.getElementById('icon-svg-restorative');
  const chill = document.getElementById('icon-svg-chill');
  const sleep = document.getElementById('icon-svg-sleep');

  // TODO: figure out how to pause/restart animations when not in viewport

  if (focus) {
    const focusTL = gsap.timeline();
    focusTL.fromTo(
      focus.querySelectorAll('circle'),
      {
        autoAlpha: 0.3,
        scale: 0.3,
        transformOrigin: "bottom center"
      },
      {
        autoAlpha: 1,
        duration: 3,
        ease: "power4.easeOut",
        repeat: -1,
        scale: 1,
        yoyo: true,
        stagger: 0.2
      }
    );
  }

  if (restorative) {
    const restorativeTL = gsap.timeline();
    restorativeTL.fromTo(
      restorative.querySelectorAll('path'),
      {
        autoAlpha: 0.3
      },
      {
        autoAlpha: 1,
        duration: 3,
        ease: "power4.easeOut",
        repeat: -1,
        rotation: (i) => (i <= 2 ? -i * 25 : i == 2 ? 0 : Math.floor(i / 2) * 25),
        transformOrigin: "bottom center",
        yoyo: true
      }
    );
  }

  if (chill) {
    const chillTL = gsap.timeline();
    chillTL.to("#icon-svg-chill-pre", {
      duration: 3,
      ease: "power4.inOut",
      morphSVG: {
        shape: "#icon-svg-chill-post",
        type: "rotational",
        origin: "50% 50%"
      },
      repeat: -1,
      yoyo: true
    });
  }

  if (sleep) {
    const sleepTL = gsap.timeline();
    sleepTL.to(sleep.querySelectorAll('line'), {
      duration: 5,
      ease: "linear",
      rotation: "+=360",
      repeat: -1,
      transformOrigin: "50% 50%"
    });
  }

}


let observerOptions = {
  rootMargin: "0px",
  threshold: 0.2
};

const observer = new IntersectionObserver(observerCallback, observerOptions);

function observerCallback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      animateIcons();
      observer.unobserve(entry.target);
    }
  });
}

// Doesn't set up the observers to respect prefers reduced motion by adding a class to the HTML and showing elements in css
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  document.querySelectorAll(".section-animated-icons").forEach((el) => {
    if (!el) return;
    observer.observe(el);
  });
} else {
  document.querySelectorAll(".section-animated-icons").forEach(section => {
    section.classList.add("prefers-reduced-motion");
    const restorative = document.getElementById('icon-svg-restorative');

    if (restorative) {
      const restorativeTL = gsap.timeline();
      restorativeTL.fromTo(
        restorative.querySelectorAll('path'),
        {
          autoAlpha: 0.3
        },
        {
          autoAlpha: 1,
          duration: 3,
          ease: "power4.easeOut",
          repeat: -1,
          rotation: (i) => (i <= 2 ? -i * 25 : i == 2 ? 0 : Math.floor(i / 2) * 25),
          transformOrigin: "bottom center",
          yoyo: true
        }
      );
      restorativeTL.progress(.5);
      restorativeTL.pause();
    }
  })
}
